var React = require('react');

function Loader (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M11 0C4.925 0 0 4.925 0 11s4.925 11 11 11 11-4.925 11-11S17.075 0 11 0zm0 2a9 9 0 110 18 9 9 0 010-18z","fill":"#F0F0F0","key":0}),React.createElement("path",{"d":"M11 0a1 1 0 010 2 9 9 0 00-9 9 1 1 0 01-2 0C0 4.925 4.925 0 11 0z","fill":"#354FA2","key":1})]));
}

Loader.defaultProps = {"viewBox":"0 0 22 22"};

module.exports = Loader;

Loader.default = Loader;
